import type { IOpportunityMSNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOpportunityMSNote,
  updateNote: updateOpportunityMSNote,
  deleteNote: deleteOpportunityMSNote,
} = makeNoteService<IOpportunityMSNote>(
  '/api/opportunitymsnotes',
  'opportunityMSNote'
)
